const breakpoints = {
    values: {
        xs: 0,
        sm: 480,
        md: 768,
        lg: 992,
        xl: 1232,
    },
};

export default breakpoints;
